<template lang="pug">
  div
    div(id="appChart")
</template>

<script>
import echarts from 'echarts'
import _ from 'lodash'
const data2 = [['人事管理风险', '滴滴司机遇害', 1553418000000], ['社会形象风险', '滴滴顺风车服务时间设置被指女性歧视', 1572994800000], ['产品风险', '网传“滴滴司机”直播性侵', 1591873200000], ['产品风险', '春秋航空拒让抑郁症乘客登机事件', 1602604800000], ['生产风险', '大众汽车停产传闻', 1607043600000], ['营销风险', '福特中国广告“指牛为马”', 1611802800000], ['社会形象风险', '特斯拉新车断电“甩锅”国家电网', 1612022400000], ['高层形象风险', '滴滴司机开车连续冲撞乘客致其身亡', 1615708800000], ['产品风险', '杭州网约车乘客跳车争议', 1623484800000], ['造谣中伤', '理想汽车座椅疑似发现水银', 1625418000000], ['营销风险', '东风标致虚假救援', 1626832800000], ['高层形象风险', '哪吒汽车高管建议请吴亦凡代言被开除事件', 1627999200000], ['人事管理风险', '比亚迪员工在出租屋猝死事件', 1637136000000], ['代言人形象风险', '小牛电动违规提速事件', 1647273600000], ['人事管理风险', '蔚来员工利用公司服务器挖矿事件', 1649214000000], ['生产风险', '长沙比亚迪工厂排污事件', 1651356000000], ['人事管理风险', '理想汽车毁约校招生', 1652230800000], ['人事管理风险', '小鹏汽车毁约20余名应届生', 1652846400000], ['营销风险', '奥迪小满广告抄袭事件公关分析', 1653062400000], ['生产风险', '蔚来汽车坠楼两名试车员身亡', 1655888400000], ['产品风险', '小鹏p7出事故安全气囊未弹出', 1656680400000], ['营销风险', '高合汽车被曝销售欺诈', 1657022400000], ['产品风险', '理想汽车在高速上起火烧成光架', 1659344400000], ['生产风险', '小鹏p7高架撞人身亡', 1660143600000]]
export default {
  name: 'EchartSankey',
  data () {
    return {
      text: '',
      data2: data2.map(t => {
        return {
          name: t[0],
          children: [
            { name: t[1] }
          ]
        }
      })
    }
  },
  mounted () {
    this.initCircle()
  },
  methods: {
    initCircle () {
      // 1.设置data格式
      let data = this.getData(this.data2)
      // 2.去重
      data = this.setArr(data)
      let links = this.getLinks(this.data2)

      console.log('data:', _.cloneDeep(data))
      console.log('links:', links)
      let chart = echarts.init(document.getElementById('appChart'))
      const option = {
        // backgroundColor: '#fff',
        // title: {
        //   subtext: 'Data From lisachristina1234 on GitHub',
        //   left: 'center'
        // },
        series: [
          {
            type: 'sankey',
            // emphasis: {
            //   focus: 'adjacency'
            // },
            layoutIterations: 0, // 严格按照自己的顺序
            left: 50.0,
            top: 20.0,
            right: 210.0,
            bottom: 25.0,
            data: data,
            links: links,
            lineStyle: {
              color: 'source',
              curveness: 0.5
            }
            // itemStyle: {
            //   color: '#1f77b4',
            //   borderColor: '#1f77b4'
            // },
            // label: {
            //   color: 'rgba(0,0,0,0.7)',
            //   fontFamily: 'Arial',
            //   fontSize: 10
            // }
          }
        ],
        tooltip: {
          trigger: 'item'
        }
      }
      chart.setOption(option)
    },
    // 调整顺序
    setOrder (data) {
      const oreder = [3, 5, 7, 1, 2, 4, 6, 8]
      const newData = data.map((t, index) => {
        return data[oreder[index]]
      })
      return newData
    },
    getData (list, noBold) {
      const datas = []
      const colors = {
        '股价下跌': '#45A786',
        '挤兑': '#94CC74',
        '人事管理风险': '#7EB08E',
        '谣言中伤': '#82B589',
        '代言人形象风险': '#6990AA',
        '生产风险': '#6183B5',
        '破产': '#D5C962',
        '社会形象风险': '#F9BC5A',
        '造谣中伤': '#40699D',
        '高层形象风险': '#4E342E'
      }
      list.forEach(t => {
        datas.push({
          name: t.name,
          itemStyle: {
            color: colors[t.name] || '#F9BC5A',
            borderColor: colors[t.name] || '#F9BC5A'
          },
          label: {
            color: '#333',
            fontWeight: noBold ? '' : 'bold',
            align: 'left'
          }
        })
        if (t.children && t.children.length > 0) {
          // 图谱的右边的文字不需要加粗
          datas.push(...this.getData(t.children, true))
        }
      })
      return datas
    },
    getLinks (list) {
      const links = []
      list.forEach(t => {
        if (t.children && t.children.length > 0) {
          t.children.forEach(child => {
            links.push({
              source: t.name,
              target: child.name,
              // value: Math.random(),
              value: 1,
              lineStyle: {

              }
            })
            if (t.children && t.children.length > 0) {
              links.push(...this.getLinks(t.children))
            }
          })
        }
      })
      return links
    },
    // 去重
    setArr (seriesData) {
      const names = seriesData.map(t => t.name)
      const result = Array.from(new Set(names))
      return result.map(t => {
        let newT = null
        seriesData.some(s => {
          if (t === s.name) {
            newT = s
          }
        })
        return newT
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#appChart {
  width: 880px;
  height: 620px;
  border: 1px solid #000;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventSearch/SearchChartItem/EchartSankey.vue